// extracted by mini-css-extract-plugin
module.exports = {"discount":"mRr1F0Ps","hide":"j_BSxyMw","content":"xm7gx0wd","item":"rwsRlP73","icon":"yqfMlJwu","carePlusInfo":"uW9MbWX5","customerService":"WBMbNuwU"};